import React, { useRef, useEffect, ReactNode } from 'react'
import 'intersection-observer'

type Props = {
    children: ReactNode
    onVisibleChange: (isVisible: boolean) => void
    className?: string
}

const Observer = ({ className, children, onVisibleChange }: Props) => {
    const observerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!observerRef.current) return
        const io = new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => {
            onVisibleChange(entry.isIntersecting)
        })
        io.observe(observerRef.current)

        return () => {
            io.disconnect()
        }
    }, [observerRef])

    return (
        <div ref={observerRef} className={className}>
            {children}
        </div>
    )
}

export default Observer
